import { nftProjects, tailwindProjects, otherProjects } from "./projectsData";
import ProjectList from "./ProjectsList/ProjectsList";
import { motion } from "framer-motion";
import "./Projects.scss";

const containerVariants = {
  //initial state
  hide: {
    opacity: 0,
    y: "100vh",
  },
  //animate state
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.5,
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    y: "-100vh",
    transition: { ease: "easeInOut", duration: 0.3 },
  },
};

const projectParaVariants = {
  hide: {
    opacity: 0,
    x: -40,
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      delay: 0.8,
      duration: 0.7,
      ease: "linear",
    },
  },
};
const projectCardsVariants = {
  hide: {
    opacity: 0,
    y: 60,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.9,
      duration: 0.7,
      ease: "linear",
    },
  },
};

const Projects = () => {
  return (
    <>
      <motion.section
        className="projects"
        variants={containerVariants}
        initial="hide"
        animate="show"
        exit="exit"
      >
        <div className="container">
          <h1 className="project-h1 display-6 text-capitalize">projects</h1>
          <motion.p
            className="project-para mt-4 mb-5"
            variants={projectParaVariants}
          >
            Here are some of the projects that i made for my{" "}
            <span style={{ color: "#64ffda" }}>Fiverr</span> clients.
          </motion.p>

          {/* --------------- TAILWIND CSS PROJECTS -------------- */}
          <motion.h4
            style={{ color: "#00ffff", letterSpacing: "3px" }}
            variants={projectParaVariants}
          >
            React and Tailwind CSS Projects
          </motion.h4>
          <motion.div className="row" variants={projectCardsVariants}>
            {tailwindProjects.map((project) => {
              return <ProjectList key={project.id} {...project} />;
            })}
          </motion.div>

          {/* --------------- NFT PROJECTS -------------- */}
          <motion.h4
            className="mt-5"
            style={{ color: "#00ffff", letterSpacing: "3px" }}
            variants={projectParaVariants}
          >
            NFT Projects
          </motion.h4>
          <motion.div className="row" variants={projectCardsVariants}>
            {nftProjects.map((project) => {
              return <ProjectList key={project.id} {...project} />;
            })}
          </motion.div>

          {/* --------------- OTHER PROJECTS -------------- */}
          <motion.h4
            className="mt-5"
            style={{ color: "#00ffff", letterSpacing: "3px" }}
            variants={projectParaVariants}
          >
            Other Projects
          </motion.h4>
          <motion.div className="row" variants={projectCardsVariants}>
            {otherProjects.map((project) => {
              return <ProjectList key={project.id} {...project} />;
            })}
          </motion.div>
        </div>
      </motion.section>
    </>
  );
};

export default Projects;
